import axios, { AxiosResponse } from 'axios';

import defaultHeaders, { HeaderOptions } from './default-headers';

interface Parameters {
  [key: string]: any;
}

export interface GetRequestOptions extends HeaderOptions {
  headers?: Record<string, string>;
}

/**
 * Get Request
 * @param url Request URL
 * @param parameters Query parameters
 * @param options Custom options for headers/auth
 * @returns Axios response
 */
const getRequest = async (
  url: string,
  parameters?: Parameters,
  options?: GetRequestOptions,
): Promise<AxiosResponse<any>> => {
  try {
    const authToken = defaultHeaders(options);
    const headers = {
      ...(authToken && authToken), // Add Authorization header if token exists
      ...options?.headers,
    };

    return await axios.get(url, { params: parameters, headers });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default getRequest;
